import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { ObjectType } from '../Enums/ObjectType.enum';
import { ReportOptionsControl } from '../Enums/ReportOptionsControl.enum';
import { ReportOptionsType } from '../Enums/ReportOptionsType.enum';

export class ReportOptionsStruct<T extends EMode = EMode.entity> {
  /** Alias: name */
  name?: string;
  /** Alias: displayName */
  displayName?: string;
  /** Alias: parameterName */
  parameterName?: string;
  /** Alias: type */
  type?: ReportOptionsControl;
  /** Alias: optionType */
  optionType?: ReportOptionsType;
  /** Alias: defaultValue */
  defaultValue?: string;
  /** Alias: showOnlyObjectTypes */
  showOnlyObjectTypes?: ObjectType[];
  /** Alias: options */
  options?: string[];

  __typename?: string;
}

const fields: FieldDefinitions<ReportOptionsStruct> = {
  name: {
    alias: 'name',
  },
  displayName: {
    alias: 'displayName',
  },
  parameterName: {
    alias: 'parameterName',
  },
  type: {
    alias: 'type',
  },
  optionType: {
    alias: 'optionType',
  },
  defaultValue: {
    alias: 'defaultValue',
  },
  showOnlyObjectTypes: {
    alias: 'showOnlyObjectTypes',
  },
  options: {
    alias: 'options',
  },
  __typename: {
    alias: '__typename',
  },
};

export const reportOptionsStructEntityDefinition: EntitiyDefinition<ReportOptionsStruct> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'ReportOptionsStruct',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
